import React from "react";
import moment from "moment";
import { isEqual } from "lodash";
import { ArrowBackIos } from "@mui/icons-material";

import useCommunicationLog from "./useCommunicationLog";
import CommunicationLogForm from "./CommunicationLogForm";
import CommunicationLogHistory from "./CommunicationLogHistory";
import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";
import ConfirmModal from "components/common/modals/confirmModal/ConfirmModal";
import { COMMUNICATION_LOG_MAX_DURATION } from "static/constants";

const CommunicationLogModal = (props) => {
  const { role } = props;
  const {
    isDeleting,
    handleClose,
    handleCancel,
    handleDelete,
    handleSubmit,
    isSubmitting,
    currentRpmRowData,
    newCommunicationLog,
    communicationLogAction,
    isCommunicationLogModal,
    handleToggleDeleteModal,
    handleToggleCancelModal,
    originalCommunicationLog,
    isCommunicationLogCancelModal,
    isCommunicationLogDeleteModal,
  } = useCommunicationLog();

  return (
    <ModalWrapper
      show={isCommunicationLogModal}
      maxWidth="md"
      title={
        <div className="d-flex align-items-center">
          {["Edit", "Add"].includes(communicationLogAction) && (
            <ArrowBackIos
              style={{ cursor: "pointer", marginRight: "10px" }}
              onClick={handleCancel}
            />
          )}
          <div className="d-flex flex-column">
            {["Edit", "Add"].includes(communicationLogAction) ? (
              <h3>{communicationLogAction} Communication Log</h3>
            ) : (
              <h3>Communication Logs</h3>
            )}
            <div
              style={{
                fontSize: "14px",
                fontWeight: "400",
                marginTop: "4px",
              }}
            >
              {currentRpmRowData?.name}
            </div>
          </div>
        </div>
      }
      onClose={handleClose}
      renderFooter={["Edit", "Add"].includes(communicationLogAction)}
      footerMessage={
        newCommunicationLog?.updated_by?.name && (
          <div
            className="d-flex flex-end"
            style={{
              width: "100%",
              fontSize: "12px",
              padding: "0 16px",
              fontWeight: "400",
            }}
          >
            {newCommunicationLog?.updated_by?.name}
          </div>
        )
      }
      actionButtons={[
        communicationLogAction === "Edit" && {
          isLeft: true,
          label: "Delete",
          variant: "text",
          style: { color: "#f44336" },
          className: "",
          onClick: () =>
            handleToggleDeleteModal(true, newCommunicationLog?._id),
          disabled: isDeleting,
        },
        {
          label: "Cancel",
          variant: "outlined",
          color: "secondary",
          onClick: () => handleToggleCancelModal(true),
          disabled: isSubmitting,
        },
        {
          label: "Save",
          onClick: handleSubmit,
          isLoading: isSubmitting,
          disabled:
            isSubmitting ||
            ["mode", "duration", "description"]
              ?.map(
                (field) =>
                  !newCommunicationLog?.[field] ||
                  newCommunicationLog?.[field]?.length === 0
              )
              ?.includes(true) ||
            !moment(newCommunicationLog?.communicated_date)?.isValid() ||
            newCommunicationLog?.duration > COMMUNICATION_LOG_MAX_DURATION ||
            isEqual(newCommunicationLog, originalCommunicationLog),
        },
      ].filter(Boolean)}
    >
      {["Edit", "Add"].includes(communicationLogAction) ? (
        <CommunicationLogForm />
      ) : (
        <CommunicationLogHistory role={role} />
      )}

      {isCommunicationLogDeleteModal && (
        <ConfirmModal
          show={isCommunicationLogDeleteModal}
          title="Delete Log"
          isConfirming={isDeleting}
          onConfirm={handleDelete}
          showCloseIcon={true}
          onCancel={() => handleToggleDeleteModal(false, null)}
          confirmButtonProps={{
            variant: "contained",
            style: {
              color: "#fff",
              backgroundColor: "#f44336",
              opacity: isDeleting ? 0.5 : 1,
            },
          }}
          cancelButtonProps={{ color: "default" }}
        >
          <div
            style={{
              fontSize: "16px",
              fontWeight: "400",
            }}
          >
            Are you sure you want to delete this log?
          </div>
        </ConfirmModal>
      )}

      {isCommunicationLogCancelModal && (
        <ConfirmModal
          show={isCommunicationLogCancelModal}
          title="Progress will not be saved"
          onConfirm={handleCancel}
          confirmText="Yes, Cancel"
          confirmButtonProps={{ style: { backgroundColor: "red" } }}
          onCancel={() => handleToggleCancelModal(false)}
          cancelText="Continue Editing"
          showCloseIcon={true}
        >
          <div
            style={{
              fontSize: "16px",
              fontWeight: "400",
            }}
          >
            Current changes will not be saved if you cancel. Are you sure you
            want to cancel?
          </div>
        </ConfirmModal>
      )}
    </ModalWrapper>
  );
};

export default CommunicationLogModal;
